<template>
  <div class="itemInfoPan">
    <table class="listTable" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <th rowspan="4">
          <div class="imgStatus">
            <img :src="this.item.image" alt="" style="height: 100px" />
          </div>
          <div class="StatusText">
            <small>{{ this.item.imageC }}</small>
          </div>
        </th>
        <th colspan="2">
          {{ item.pdescribe }}
          <small style="float: right; margin: 1px; margin-right: 15px">
            {{ item.name }}</small
          >
        </th>
      </tr>
      <tr>
        <td>
          <svg-icon icon-class="place" class="MapArrorSvg" style="width: 18px; height: 18px"></svg-icon>
        </td>
        <td>
          <small
            style="text-decoration: underline; cursor: pointer"
            @click="mapjump(item)"
            >{{ this.item.pdetail }}</small
          >
        </td>
      </tr>
      <tr>
        <td>
          <svg-icon
            icon-class="time"
            class="MapArrorSvg"
            style="width: 18px; height: 18px"
          ></svg-icon>
        </td>
        <td>
          <small>{{ this.item.openingText?this.item.openingText.split("&#")[0]:"" }}</small>
        </td>
      </tr>
      <tr>
        <td>
          <svg-icon
            icon-class="prompt"
            class="MapArrorSvg"
            style="width: 18px; height: 18px"
          ></svg-icon>
        </td>
        <td>
          <small>{{ this.item.openingText?this.item.openingText.split("&#")[1]:"" }}</small>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { jumpGoogle } from "@/utils/mapjump.js";
export default {
  props: ["item"],
  mounted() {},
  methods: {
    mapjump(val) {
      if (val.platLng) {
        console.log(val, 999);
        jumpGoogle(val);
      } else {
        this.$message("暂无信息");
      }
    },
  },
  watch: {
    item: {
      handler(newValue, oldValue) {},
      deep: true,
    },
  },
};
</script>

<style scoped>
.itemInfoPan {
  padding: 0;
  margin: 0;
}
.imgStatus {
  text-align: center;
}
.StatusText {
  text-align: center;
}
.listTable td:first-child {
  display: inline-block;
  margin-right: 5px;
}
.listTable td:nth-child(2) {
  vertical-align: top;
  width: 100%;
}
.listTable th:first-child {
  width: 30%;
  height: 30%;
  padding-right: 10px;
}
.listTable th:last-child {
  font-size: 20px;
  padding: 0;
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
  vertical-align: top;
}
</style>
